import {Ability, AbilityBuilder, AbilityClass} from "@casl/ability";
import EventCatalogueRuleset from "./ruleSets/eventCatalogueRuleset";
import AnnouncementRuleset from "./ruleSets/announcementRuleset";
import RulesetBase from "./ruleSets/rulesetBase";
import NoticeRuleset from "./ruleSets/noticeRuleset";
import ResidentAdminRuleset from "./ruleSets/residentAdminRuleset";
import ReleasedEventRuleset from "./ruleSets/releasedEventRuleset";
import MultiVillageRuleset from "./ruleSets/mulitVillageRuleset";
import TransactionRuleset from "./ruleSets/transactionRuleset";
import OccasionsRuleset from "./ruleSets/occasionsRuleset";
import MetricsRuleset from "./ruleSets/metricsRuleset";

type Actions = "Create" | "Read" | "Update" | "Delete";
type Subjects =
  | "Event"
  | "ReleasedEvent"
  | "EventCatalogue"
  | "Occasion"
  | "Notice"
  | "Announcement"
  | "ResidentAdmin"
  | "MultiVillage"
  | "ProcessedBooking"
  | "Metrics";

export type AppAbilityType = Ability<[Actions, Subjects]>;
export const AppAbility = Ability as AbilityClass<AppAbilityType>;

const rulesets: Array<typeof RulesetBase> = [
  EventCatalogueRuleset,
  OccasionsRuleset,
  AnnouncementRuleset,
  ResidentAdminRuleset,
  NoticeRuleset,
  ReleasedEventRuleset,
  MultiVillageRuleset,
  TransactionRuleset,
  MetricsRuleset
];

/**
 * Define a set of rules based on permissions of the user.
 */
const defineRulesFor = (userPermissions: string[], roles: string[] | null) => {
  const abilityBuilder = new AbilityBuilder(AppAbility);

  rulesets.forEach((ruleset) => {
    //@ts-ignore
    const rulesetObject = new ruleset(abilityBuilder);
    rulesetObject.defineRules(userPermissions, roles);
  });

  return abilityBuilder.rules;
};

/**
 * Build the abilities of the user on the app based on the user's permissions.
 * If the user is a super admin, the permissions object will contain all possible permissions.
 */
export const buildAbilityFor = (
  permissions: string[],
  roles: string[] | null
): AppAbilityType => {
  return new AppAbility(defineRulesFor(permissions, roles));
};
